/* eslint-disable */
export default {
  searchPlaceholder: '搜索…',
  refresh: '刷新',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
